import {useGetConfigMutation} from 'hooks/ventrata/useGetConfigMutation'
import React, {useContext, useEffect, useState} from 'react'
import {Ventrata} from 'types'

type Props = {
  children: React.ReactNode
}

export const ConfigContext = React.createContext<Ventrata.Config | null>(null)

export const ConfigProvider = ({children}: Props) => {
  const [config, setConfig] = useState<Ventrata.Config | null>(null)

  const getConfigMutation = useGetConfigMutation()

  const getConfig = getConfigMutation.mutate

  useEffect(() => {
    getConfig(undefined, {
      onSuccess: setConfig,
    })
  }, [getConfig])

  if (!config) {
    return null
  }

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
}

export const useConfig = () => {
  const config = useContext(ConfigContext)

  if (!config) {
    throw new Error('Config is null')
  }

  return config
}
